import { jsx, jsxs } from "react/jsx-runtime";
import { X } from "@tamagui/lucide-icons";
import {
  Adapt,
  Button,
  Dialog,
  Fieldset,
  Input,
  Label,
  Paragraph,
  Sheet,
  TooltipSimple,
  Unspaced,
  YStack
} from "tamagui";
import { SelectDemoItem } from "./SelectDemo";
function DialogDemo() {
  return /* @__PURE__ */ jsxs(Dialog, { modal: true, children: [
    /* @__PURE__ */ jsx(Dialog.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(Button, { children: "Edit Profile" }) }),
    /* @__PURE__ */ jsx(Adapt, { when: "sm", platform: "touch", children: /* @__PURE__ */ jsxs(Sheet, { zIndex: 2e5, modal: true, dismissOnSnapToBottom: true, children: [
      /* @__PURE__ */ jsx(Sheet.Frame, { padding: "$4", space: true, children: /* @__PURE__ */ jsx(Adapt.Contents, {}) }),
      /* @__PURE__ */ jsx(Sheet.Overlay, {})
    ] }) }),
    /* @__PURE__ */ jsxs(Dialog.Portal, { children: [
      /* @__PURE__ */ jsx(
        Dialog.Overlay,
        {
          animation: "quick",
          opacity: 0.5,
          enterStyle: { opacity: 0 },
          exitStyle: { opacity: 0 }
        },
        "overlay"
      ),
      /* @__PURE__ */ jsxs(
        Dialog.Content,
        {
          bordered: true,
          elevate: true,
          animation: [
            "quick",
            {
              opacity: {
                overshootClamping: true
              }
            }
          ],
          enterStyle: { x: 0, y: -20, opacity: 0, scale: 0.9 },
          exitStyle: { x: 0, y: 10, opacity: 0, scale: 0.95 },
          space: true,
          children: [
            /* @__PURE__ */ jsx(Dialog.Title, { children: "Edit profile" }),
            /* @__PURE__ */ jsx(Dialog.Description, { children: "Make changes to your profile here. Click save when you're done." }),
            /* @__PURE__ */ jsxs(Fieldset, { space: "$4", horizontal: true, children: [
              /* @__PURE__ */ jsx(Label, { width: 160, justifyContent: "flex-end", htmlFor: "name", children: "Name" }),
              /* @__PURE__ */ jsx(Input, { flex: 1, id: "name", defaultValue: "Nate Wienert" })
            ] }),
            /* @__PURE__ */ jsxs(Fieldset, { space: "$4", horizontal: true, children: [
              /* @__PURE__ */ jsx(Label, { width: 160, justifyContent: "flex-end", htmlFor: "username", children: /* @__PURE__ */ jsx(TooltipSimple, { label: "Pick your favorite", placement: "bottom-start", children: /* @__PURE__ */ jsx(Paragraph, { children: "Food" }) }) }),
              /* @__PURE__ */ jsx(SelectDemoItem, {})
            ] }),
            /* @__PURE__ */ jsx(YStack, { alignItems: "flex-end", marginTop: "$2", children: /* @__PURE__ */ jsx(Dialog.Close, { displayWhenAdapted: true, asChild: true, children: /* @__PURE__ */ jsx(Button, { theme: "alt1", "aria-label": "Close", children: "Save changes" }) }) }),
            /* @__PURE__ */ jsx(Unspaced, { children: /* @__PURE__ */ jsx(Dialog.Close, { asChild: true, children: /* @__PURE__ */ jsx(
              Button,
              {
                position: "absolute",
                top: "$3",
                right: "$3",
                size: "$2",
                circular: true,
                icon: X
              }
            ) }) })
          ]
        },
        "content"
      )
    ] })
  ] });
}
export {
  DialogDemo
};
//# sourceMappingURL=DialogDemo.js.map
